import type { BannerNamespace, BannerPromotion, BannerThemeVars } from "../types";
import { getConfig } from "../config";
import { fetchPromotion } from "./api";
import {
  open as openRenderer,
  close as closeRenderer,
  isOpen as isOpenRenderer,
} from "./renderer";
import { shouldShowBanner } from "../storage/banner";

let currentPromotion: BannerPromotion | null = null;
let currentTheme: BannerThemeVars = {};

export async function initBanner(): Promise<void> {
  const { banner: bannerConfig } = getConfig();
  const result = await fetchPromotion();

  if (!result.success || !result.promotion) return;

  currentPromotion = result.promotion;
  currentTheme = bannerConfig?.theme ?? {};

  const remember = bannerConfig?.remember ?? true;
  if (
    remember &&
    !shouldShowBanner(
      currentPromotion.id,
      currentPromotion.updatedAt,
    )
  ) {
    return;
  }

  openRenderer(currentPromotion, bannerConfig, currentTheme);
}

function open(payload?: BannerPromotion): void {
  const { banner: bannerConfig } = getConfig();
  const promotion = payload ?? currentPromotion;
  if (!promotion) return;
  if (payload) currentPromotion = payload;
  openRenderer(promotion, bannerConfig, currentTheme);
}

function close(): void {
  closeRenderer();
}

function isOpen(): boolean {
  return isOpenRenderer();
}

function setTheme(vars: BannerThemeVars): void {
  currentTheme = { ...currentTheme, ...vars };
}

export const banner: BannerNamespace = {
  init: initBanner,
  open,
  close,
  isOpen,
  setTheme,
};
